import React from 'react';



const InformationArea = () => {
  return (
    <section id="note">
      <dl>
        <dt>URL短縮について</dt>
        <dd>LodestoneのURLが短縮できます。</dd>		
        <dd><strong>https://ffxiv.link/00000</strong> のような短縮URLが生成されます。</dd>
        <dd>ffxiv.linkから転送されるサイトはLodestone及び管理人「<a href="https://twitter.com/vast_z" target="_blank" rel="noopener noreferrer">Vast</a>」が運営するサイトのみです。</dd>
        <dd>転送先サイトが限定されているため、予期しないサイトに転送される心配はありません。</dd>
        <dd>手入力による利便性を考慮し、短縮URL末尾はランダム文字列ではなく連番の数値となります。</dd>
        <dd>適当に数字を変えれば、他人に見らる可能性もあるため、第3者に見られたくない場合のご利用はお勧めしません。</dd>
        <dd>生成されたURLの削除や再発行はできません。</dd>
        <dd>当サイトに関するバグ報告や質問などは「<a href="https://x.com/vast_z" target="_blank" rel="noopener noreferrer">@vast_z</a>」もしくは「<a href="mailto:info@ffxiv-pt.com">info@ffxiv-pt.com</a>」までお願い致します。</dd>
        <dd>当サイトを利用して起きたいかなるトラブルについても、当サイトは一切責任を負いません。</dd>
      </dl>
    </section>
  );
};

export default InformationArea;